import {CircleHelp} from '@UI/components/icons/CircleHelp.tsx'
import {MapPin} from '@UI/components/icons/MapPin.tsx'
import {MapPinOff} from '@UI/components/icons/MapPinOff.tsx'
import {Colors} from '@UI/theme/generated/Colors.ts'
import {Body_14_Coral_Empasis_14} from '@UI/typography/generated/typography.tsx'
import {GeoState, useGpsStore} from '../../Store/gpsStore.ts'
import {Gt} from '../../i18n/Gt.tsx'
import {Stack} from '../Stack/Stack.tsx'
import styles from './gpsStatusButton.module.less'
import cn from "classnames";

export const GpsStatusButton = ({ignoreMobileScheme}: {ignoreMobileScheme?: boolean}) => {
    const state = useGpsStore(x => x.state)
    const setShowInstructions = useGpsStore(x => x.setShowInstructions)
    if (state === GeoState.granted)
        return (
            <Stack gap={2} alignItems={'center'} className={styles.gpsButton} style={{color: Colors.Coral_green_500}}>
                <MapPin color={Colors.Coral_green_500}/>
                <Body_14_Coral_Empasis_14>
                    <Gt>GPS connected</Gt>
                </Body_14_Coral_Empasis_14>
            </Stack>
        )

    return (
        <Stack
            gap={2}
            alignItems={'center'}
            className={styles.gpsButton}
            style={{color: Colors.Coral_special_Error_red, cursor: 'pointer'}}
            onClick={() => setShowInstructions(true)}
        >
            <MapPinOff color={Colors.Coral_special_Error_red}/>
            <div className={cn({[styles.gpsButtonText]: !ignoreMobileScheme})}>
                <Body_14_Coral_Empasis_14>
                    <Gt>GPS not connected</Gt>
                </Body_14_Coral_Empasis_14>
            </div>
            <CircleHelp color={Colors.Coral_special_Error_red} size={20} className={cn({[styles.gpsQuestionIco]: !ignoreMobileScheme})}/>
        </Stack>
    )
}
